import { render, staticRenderFns } from "./highlight-expand.vue?vue&type=template&id=4b28ee98&scoped=true&"
import script from "./highlight-expand.vue?vue&type=script&lang=js&"
export * from "./highlight-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28ee98",
  null
  
)

export default component.exports